import { render, staticRenderFns } from "./App.vue?vue&type=template&id=60c538a0&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=60c538a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c538a0",
  null
  
)

export default component.exports